<div class="grid" *ngIf="!carInformacionInicial">

  <div class="col-12" *ngIf="editar && !faltaConfigurarPaso">
    <form [formGroup]="formularioPasos" (ngSubmit)="onSubmit()"
          novalidate id="fCanalesPasos" name="fCanalesPasos" >
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'CONFIGURACIONCANALESESTADO.LBL_PASO' | translate }}</label>
            <p-multiSelect id="idPasosCanal" name="nomPasosCanal" [options]="listaPasos" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}" formControlName="idFlujoVentaPaso"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fControls.idFlujoVentaPaso.invalid">
              {{ 'CONFIGURACIONCANALESESTADO.LBL_PASO' | translate}} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>
        <div class="col-3 md:col-3 lg:col-3" style="padding-top: 30px; padding-left: 50px;">
          <p-checkbox label="{{ 'CONFIGURACIONCANALESESTADO.LBL_OBLIGATORIO' | translate}}" binary="true"
                      id="indicador"
                      name="nomIndicador"
                      formControlName="indicadorObligatorio"></p-checkbox>
        </div>
        <div class="col-3 md:col-3 lg:col-3">
          <div *ngIf="!guardando">
            <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="col-12" *ngIf="showTable && !faltaConfigurarPaso">
    <p-table [columns]="columnas" [loading]="carTabla" #dt
             [value]="listaPasosCanal" selectionMode="single"
             [paginator]="true" [rows]="10"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{row.flujoVentaPaso}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorObligatorio" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group" *ngIf="!cargandoControles">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-file-text-o" data-toggle="tooltip"
                      title="{{'CONFIGURACIONCANALESESTADO.BTN_EDITARCONTROLES' | translate}}" pButton
                      *ngIf="row.codigoFlujoVentaPaso !== 'POLALE'"
                      (click)="editarControles(row)"></button>
              <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                      title="{{'BTN_ELIMINAR' | translate}}" *ngIf="row.codigoFlujoVentaPaso !== 'DATBAS' && row.codigoFlujoVentaPaso !== 'FINPRO' && editar"
                      pButton (click)="inhabilitarPasoCanal(row)"></button>
            </div>
            <div *ngIf="cargandoControles">
              <i class="fa fa-refresh fa-spin fa-fw"></i><br>
              <span>{{'LBL_CARGANDO' | translate }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-12" *ngIf="!showTable && !faltaConfigurarPaso">
    <div *ngIf="guardando">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
      <span>{{'LBL_GUARDANDO' | translate }}</span>
    </div>
  </div>
  <div class="col-12 text-center" *ngIf="faltaConfigurarPaso">
    <h3>{{ 'CONFIGURACIONCANALESESTADO.MSG_FALTACONFIGURACIONPASO' | translate }}</h3>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<p-dialog
  header="{{ 'CONFIGURACIONCANALESESTADO.LBL_SELECCIONCAMPOS' | translate}}" [positionTop]="(altoPantalla/2)-(altoMedidaModal/2)" [closable]="false"
  [(visible)]="showConfigControls" [contentStyle]="medidaModal" appendTo="body" [modal]="true" *ngIf="showConfigControls"
  [draggable]="false" [positionLeft]="(anchoPantalla/2)-(anchoMedidaModal/2)+50">
  <app-canal-estado-paso-control-producto
    [configuracionCanalPaso]="configCanalPasoControl" [editar]="editar" *ngIf="!pasoPolitica"></app-canal-estado-paso-control-producto>
  <app-canal-estado-paso-politica-producto [configuracionCanalPaso]="configCanalPasoControl" [editar]="editar" *ngIf="pasoPolitica">

  </app-canal-estado-paso-politica-producto>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrarModal()"></button>
    </div>
  </div>
</p-dialog>
